<template>
  <div class="card">
    <div class="card-body" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form @submit="submit" class="add-edit-form product-form">
              <div class="row">
                <div class="col-lg-6">
                  <label for>
                    <span>Banner Title:</span>
                    <input v-model="homepageBanner.title" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Banner Description:</span>
                    <textarea v-model="homepageBanner.description" type="text" class="form-control" rows="6"/>
                  </label>
                  <label for>
                    <span>Banner Image</span>
                    <section class="form-control replace" :class="{'d-none': !isObject(homepageBanner.image)}">
                      <input type="button" class="replace-btn" data-id="image" value="Replace File">
                      <span>{{homepageBanner.image}}</span>
                    </section>
                    <input :class="{'d-none': isObject(homepageBanner.image)}" @change="onFileChange($event, 'image')" type="file" id="image" class="form-control" />
                  </label>
                </div>
                <div class="col-lg-6">
                  <div class="thumbnail-display"></div>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">{{toEdit ? 'Update' : 'Save'}}</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-6"></div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import HomepageBanner from '@/models/HomepageBanner'
export default{
  name: 'HomepageBannerForm',
  data () {
    return {
      homepageBanner: new HomepageBanner()
    }
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetchHomepageBanner()
    }
    $('.thumbnail-display').click(function () {
      $('#thumbnail').click()
    })

    $(document).on('change', '#image', function () {
      if (event.target.files.length) { $('.thumbnail-display').css('background-image', 'url(' + window.URL.createObjectURL(event.target.files[0]) + ')') } else { $('.thumbnail-display').css('background-image', 'none') }
    })

    $('.card').on('click', '.replace-btn', function () {
      var id = $(this).attr('data-id')
      $('#' + id).click()
    })
  },
  methods: {
    fetchHomepageBanner () {
      this.$store.dispatch('fetchHomepageBanner', this.$route.params.id)
        .then((result) => {
          this.homepageBanner = new HomepageBanner(result.data.homepageBanner)
          $('.thumbnail-display').css('background-image', 'url("' + this.homepageBanner.imageUrl + '")')
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    },
    submit (event) {
      event.preventDefault()
      var homepageBanner = this.homepageBanner.getFormData()
      var functionName = 'createHomepageBanner'
      var successText = 'created'
      if (this.toEdit) { functionName = 'editHomepageBanner'; successText = 'edited' }
      this.$store.dispatch(functionName, homepageBanner)
        .then(() => {
          this.$router.push('/homepage-banners')
          this.$toast.success('Homepage Banner ' + successText + ' successfully')
        })
        .catch((err) => {
          console.log(err.response)
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    },
    onFileChange (e, index) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.homepageBanner[index] = null
        index = null
      } else { this.homepageBanner[index] = files[0] }
    },
    isObject (val) {
      if (this.toEdit && !(val === 'null' || val === '')) { return true }
      return (typeof val === 'object')
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 767px) {
  .cat-div {
    width: 100% !important;
  }
}
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/HomepageBannerForm.vue